__turbopack_context__.v({
  "button": "button-module-scss-module__WBuRGq__button",
  "buttonGray": "button-module-scss-module__WBuRGq__buttonGray",
});
